import React from 'react'

interface Props {
  value?: string | number | null
  negative: string
  neutral: string
  positive: string
}

export const ValueSwitch: React.FC<Props> = ({
  value,
  negative,
  neutral,
  positive,
}) => {
  const parsedValue = !!value ? parseFloat(String(value)) : 0

  const stringRenderer = () => {
    if (parsedValue < 0) {
      return negative
    }
    if (parsedValue > 0) {
      return positive
    }
    return neutral
  }

  return <>{stringRenderer()}</>
}
